export default {
  path: '/resource',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "index",
    },
    {
      path: "index",
      component: () => import('../components/resource/Index'),
    },
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/resource.js